import Link from "@/components/Link"
import { useSelfUserQuery } from "@/data/queries"
import { ROUTES } from "@/routes"
import cn from "@/utils/cn"
import { ComponentPropsWithoutRef } from "react"

type NavigationProps = ComponentPropsWithoutRef<"nav">

const Navigation = ({ className, ...otherProps }: NavigationProps) => {
  const { data: user } = useSelfUserQuery()

  return (
    <nav
      className={cn(
        "static top-0 flex w-full flex-row items-center justify-between",
        className
      )}
      {...otherProps}
    >
      <Link to={ROUTES.POPULATION.ROOT}>
        <img src="/logo.svg" alt="Bloomlife logo" className="h-6" />
      </Link>
      {user && (
        <div className="flex items-center gap-3 text-sm">
          <p>{`${user.displayName}`}</p>
        </div>
      )}
    </nav>
  )
}

export default Navigation
